export const formatCurrency = (amount: number | string, currency: string = 'USD') => {
  if (amount === null || amount === undefined || isNaN(Number(amount))) {
    return amount;
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount));
};
